
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#29c97c",
        "d": "M512 120.470588c-84.329412 0-150.588235 66.258824-150.588235 150.588236v271.058823c0 84.329412 66.258824 150.588235 150.588235 150.588235s150.588235-66.258824 150.588235-150.588235V271.058824c0-84.329412-66.258824-150.588235-150.588235-150.588236z"
      }
    }
  ]
})
    }
  